import React, { memo, useEffect, useRef, useState } from 'react';
import {
  View,
  StatusBar,
  SafeAreaView,
  Text,
  NativeModules,
  Platform,
} from 'react-native';
import { CHEVRON_LEFT, NOTIFICATION_ICON } from '../../assets';
import { useDispatch, useSelector } from 'react-redux';
import { getCleanUrl, isAndroid } from '../../utils/Helper';
import { ImageComp } from '../Image/Image';
import { HOTEL_SELECTOR_WIDGET, NOTIFICATION } from '../../navigation/StackNavigator/routes';
import CustomPressable from '../customPressable/customPressable';
import { useCssStyle } from '../../customHook/getCssStyle';
import { useTranslation } from 'react-i18next';
import { IS_CHILD_CONNECTOR } from '../../config/Constant';
import { useNavigation } from '@react-navigation/native';
import { setCurrentWidget } from '../../Redux/Reducers/deviceConfigReducer';
import { setRenderIpChangeModal } from '../../Redux/Reducers/appConfigReducer';

const { StatusBarManager } = NativeModules;

const Header = () => {

  const getStyles = useCssStyle();
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const navigation = useNavigation();

  const { webAppWidgetsInfo } = useSelector(state => state.deviceConfigSlice);
  const { notifications, newMessagesCount } = useSelector(state => state.notificationSlice);

  const [statusBarHeight, setStatusBarHeight] = useState(0);
  
  const tapCountRef = useRef(0);
  const tapTimerRef = useRef(null);

  const hotelLogoImageUrl =
    webAppWidgetsInfo?.durations[0]?.brandingInfo?.hotelLogoImageUrl;
  const logoUrl = getCleanUrl(hotelLogoImageUrl);

  const handleNotificationPress = () => {
    navigation.navigate(NOTIFICATION)
  }

  const renderNotificationCount = () => {
    if (newMessagesCount >= 1) {
      return (

        <View style={getStyles(['notificationicon_countcontainer_unread'])}>
          <Text style={getStyles(['notificationicon_countcontainer_unread_text'])}>{newMessagesCount}</Text>
        </View>
      )
    }

    if (notifications.length > 0) {
      return (

        <View style={getStyles(['notificationicon_countcontainer'])}>
          <Text style={getStyles(['notificationicon_countcontainer_text'])}>{notifications.length}</Text>
        </View>
      )
    }

  };

  const handleLocationPress = () => {
    dispatch(setCurrentWidget({ widgetType: "Hotel Selector" }));
    navigation.navigate(HOTEL_SELECTOR_WIDGET);
  }


  const getStatusBarHeight = () => {
    if (Platform.OS === 'ios') {
      StatusBarManager.getHeight((height) => setStatusBarHeight(height.height || 0));
    } else {
      setStatusBarHeight(StatusBar.currentHeight || 0);
    }
  }


  useEffect(() => {
    getStatusBarHeight();

  }, [])

  const handleLogoPress = () => {
    tapCountRef.current += 1;

    if (tapTimerRef.current) {
      clearTimeout(tapTimerRef.current);
    }
    
    tapTimerRef.current = setTimeout(() => {
      tapCountRef.current = 0;
    }, 5000);

    if (tapCountRef.current === 5) {
      tapCountRef.current = 0;
      clearTimeout(tapTimerRef.current);

      dispatch(setRenderIpChangeModal(true))
    }
  }

  return (
    <View style={getStyles([{ paddingTop: statusBarHeight }, 'headerContainer'])} id='headerContainer'>
      <View style={getStyles(['headerContainerInner'])} id='headerContainerInner'>

        <View style={getStyles(['headerContainerInnerCompLeft'])} id='headerContainerInnerCompLeft'>

          {IS_CHILD_CONNECTOR &&
            <CustomPressable style={getStyles(['locationIconContainer'])} onPress={handleLocationPress} id='locationIconContainer'>
              <ImageComp source={CHEVRON_LEFT} style={getStyles(['locationIcon'])} id='locationIcon' />
              <Text style={getStyles(['locationText'])} id='locationText'>{t('header.location')}</Text>
            </CustomPressable>
          }
        </View>
        <CustomPressable onPress={null} style={getStyles(['headerContainerLogoContainer'])} id='headerContainerLogoContainer'>
          <ImageComp source={logoUrl} style={getStyles(['headerContainerLogo'])} id='headerContainerLogo' />
        </CustomPressable>

        <View style={getStyles(['headerContainerInnerCompRight'])} id='headerContainerInnerCompRight' >
          <CustomPressable onPress={handleNotificationPress} style={getStyles(['notificationIconContainer'])} id='notificationIconContainer'>
            <ImageComp source={NOTIFICATION_ICON} style={getStyles(['notificationIcon'])} id='notificationIcon' />
            {renderNotificationCount()}
          </CustomPressable>
        </View>
      </View>
    </View>
  );
};

export default memo(Header);
